<template>
  <section class="app-main tableloading">

    <breadcrumb class="breadcrumb-container" />
    <transition name="fade-transform" mode="out-in">
      <div class="boxContainer">
        <router-view :key="key" />
      </div>
    </transition>
  </section>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: {
    Breadcrumb
  },
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f8fffc;
  margin-top: 74px;
}
</style>

<style lang="scss" scoped>
// fix css style bug in open el-dialog
.breadcrumb-container{
  display: flex;
  align-items: center;
}
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.boxContainer {
//   height: calc(80vh);
}
.boxContainer .app-container {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue